(function () {
  'use strict';

  const root = document.getElementById('ym-preview');
  if (!root) return;

  // ============================================================
  //  Config from data attributes
  // ============================================================
  const locale = (root.dataset.locale || 'fr').toLowerCase();
  const apiUrl = root.dataset.apiUrl || '';
  const VARIANTS = {
    express:   { id: root.dataset.variantExpress, price: root.dataset.variantExpressPrice, compare: root.dataset.variantExpressCompare },
    standard:  { id: root.dataset.variantStandard, price: root.dataset.variantStandardPrice, compare: root.dataset.variantStandardCompare },
    streaming: { id: root.dataset.variantStreaming, price: root.dataset.variantStreamingPrice }
  };

  // ============================================================
  //  i18n
  // ============================================================
  const I18N = {
    fr: {
      heroPrefix: "Découvrez la chanson personnalisée de ",
      heroSuffix: "",
      playLabel: "Cliquez pour écouter",
      pauseLabel: "Pause",
      previewLabel: "⏱ Extrait",
      durationLabel: "Aperçu 60s",
      lockedLabel: "Chanson complète verrouillée",
      emotionText: "Imaginez l'émotion sur le visage de <strong>{name}</strong> à l'écoute de cette chanson 😍. Un cadeau à garder précieusement, pour toujours.",
      capacityMain: "Plus que 3 places dans les prochaines 24h",
      capacitySub: "Pour préserver la qualité, notre studio ne produit qu'un nombre limité de chansons par jour.",
      expiryLabel: "Votre extrait reste en ligne encore",
      expirySub: "Notre studio ne conserve pas les démos en ligne au-delà de 24h. Réservez votre chanson maintenant : <strong>on la retravaille ensuite gratuitement, autant de fois qu'il faut, jusqu'à ce qu'elle vous plaise à 100%.</strong>",
      studioNoteLabel: "✍️ Le mot du studio",
      studioNoteSign: "Le studio YourMelody",
      studioNoteFallback: "<strong>{name}</strong> a vraiment de la chance de vous avoir. Merci de nous avoir confié cette chanson, on l'a composée avec beaucoup de soin et on espère du fond du cœur qu'elle vous plaira.",
      stickyCap: "L'extrait disparaît · 3 places restantes",
      stickyCapShort: "3 places restantes",
      stickyBtn: "Débloquer",
      offerLabel: "OFFRE LIMITÉE",
      unlockPrefix: "Débloquez la chanson complète de ",
      unlockSuffix: "",
      offerSub: "Cette offre exceptionnelle ne durera pas",
      expressTitle: "Livraison en 30 minutes",
      expressB1: "Chanson complète dans votre boîte mail en 30 min",
      expressB2: "Priorité absolue en studio",
      expressB3: "Offre unique",
      popularBadge: "LE PLUS POPULAIRE",
      standardTitle: "Livraison 24h",
      standardDesc: "Même chanson, livrée sous 24 heures",
      streamingTitle: "Ajouter le streaming Spotify & Apple Music",
      streamingDesc: "Votre chanson publiée sur toutes les plateformes. Partagez-la partout.",
      ctaMain: "Débloquer la chanson complète",
      trust1: "Accès instantané",
      trust2: "À vous pour toujours",
      guaranteeTitle: "Satisfaction garantie",
      guaranteeBody: "Pas satisfait ? On modifie la chanson gratuitement jusqu'à ce qu'elle vous plaise.",
      socialProof: "Plus de 15 000 chansons livrées avec amour",
      includedTitle: "Ce qui est inclus",
      inc1Title: "Accès instantané",
      inc1Desc: "Disponible immédiatement après achat",
      inc2Title: "Hébergée à vie",
      inc2Desc: "Accessible sur tous vos appareils",
      inc3Title: "Téléchargement",
      inc3Desc: "Fichier audio en haute qualité",
      inc4Title: "Modifications gratuites",
      inc4Desc: "Jusqu'à ce qu'elle vous plaise",
      faqTitle: "Questions fréquentes",
      faqQ1: "Comment vais-je recevoir ma chanson ?",
      faqA1: "Votre chanson complète vous sera envoyée par email sous forme de fichier MP3 haute qualité, avec un lien privé pour l'écouter et la télécharger.",
      faqQ2: "Le paiement est-il sécurisé ?",
      faqA2: "Oui. Tous les paiements sont traités par Shopify avec un chiffrement bancaire. Nous ne stockons jamais vos données de carte.",
      faqQ3: "Puis-je demander des modifications ?",
      faqA3: "Absolument. Vous avez 7 jours après réception pour demander des modifications gratuites illimitées jusqu'à ce que la chanson vous plaise.",
      faqQ4: "Quel format audio est-ce que je reçois ?",
      faqA4: "Un MP3 haute qualité (320 kbps), prêt à être lu sur tout appareil, partagé, ou importé dans votre bibliothèque musicale.",
      loading: "Chargement de votre extrait…",
      errorTitle: "Extrait introuvable",
      errorBody: "Le lien que vous avez utilisé n'est pas valide ou a expiré.",
      errorCta: "Recommencer le quiz",
      pendingTitle: "Votre extrait se prépare…",
      pendingBody: "Nous composons votre chanson personnalisée. Vous recevrez un email dès qu'elle sera prête.",
      pendingHint: "L'attente moyenne est de 30 à 60 minutes. Cette page se mettra à jour automatiquement.",
      cartError: "Une erreur est survenue. Vérifiez votre connexion et réessayez.",
      saveLabel: "Économie",
      // line item property labels (FR)
      propRecipient: "Pour qui",
      propRecipientName: "Prénom destinataire",
      propStyle: "Style",
      propOccasion: "Occasion",
      propPreviewUrl: "Extrait écouté",
      propStylePrompt: "Style musical",
      propLyrics: "Paroles"
    },
    en: {
      heroPrefix: "Discover ",
      heroSuffix: "'s personalized song",
      playLabel: "Tap to play preview",
      pauseLabel: "Pause",
      previewLabel: "⏱ Preview",
      durationLabel: "60s preview",
      lockedLabel: "Full song locked",
      emotionText: "Picture the look on <strong>{name}</strong>'s face hearing this song 😍. A timeless gift to treasure forever.",
      capacityMain: "Only 3 slots left in the next 24h",
      capacitySub: "To keep the quality high, our studio only produces a limited number of songs each day.",
      expiryLabel: "Your preview stays online for",
      expirySub: "Our studio doesn't keep demos online beyond 24h. Order your song now: <strong>we then fine-tune it for free, as many times as it takes, until you love it.</strong>",
      studioNoteLabel: "✍️ A note from our studio",
      studioNoteSign: "The YourMelody studio",
      studioNoteFallback: "<strong>{name}</strong> is so lucky to have you. Thank you for trusting us with this song. We crafted it with great care and truly hope you'll love it.",
      stickyCap: "Preview disappears · 3 slots left",
      stickyCapShort: "3 slots left",
      stickyBtn: "Unlock",
      offerLabel: "LIMITED OFFER",
      unlockPrefix: "Unlock ",
      unlockSuffix: "'s full song now",
      offerSub: "This special pricing won't last forever",
      expressTitle: "30-Minute Delivery",
      expressB1: "Full song in your inbox in 30 minutes",
      expressB2: "Studio absolute priority",
      expressB3: "One time offer",
      popularBadge: "MOST POPULAR",
      standardTitle: "24-Hour Delivery",
      standardDesc: "Same song, delivered within 24 hours",
      streamingTitle: "Add Spotify & Apple Music streaming",
      streamingDesc: "Your song published on all major platforms. Share it everywhere.",
      ctaMain: "Unlock Full Song Now",
      trust1: "Instant access",
      trust2: "Yours forever",
      guaranteeTitle: "Satisfaction Guaranteed",
      guaranteeBody: "Not happy? We'll revise it for free until you love it.",
      socialProof: "15,000+ custom songs delivered with love",
      includedTitle: "What's Included",
      inc1Title: "Instant access",
      inc1Desc: "Unlock immediately after purchase",
      inc2Title: "Hosted forever",
      inc2Desc: "Access on any device, anytime",
      inc3Title: "Download anytime",
      inc3Desc: "HD audio file",
      inc4Title: "Free revisions",
      inc4Desc: "Until you love it",
      faqTitle: "Frequently Asked Questions",
      faqQ1: "How will I receive my song?",
      faqA1: "Your full song will be sent by email as a high-quality MP3 file, with a private link to listen and download.",
      faqQ2: "Is my payment secure?",
      faqA2: "Yes. All payments are processed by Shopify with bank-grade encryption. We never store your card details.",
      faqQ3: "Can I request modifications?",
      faqA3: "Absolutely. You have 7 days after delivery to request unlimited free revisions until you love it.",
      faqQ4: "What audio format do I get?",
      faqA4: "A high-quality MP3 (320 kbps) ready to play on any device, share, or import into your music library.",
      loading: "Loading your preview…",
      errorTitle: "Preview not found",
      errorBody: "The link you used is invalid or has expired.",
      errorCta: "Start over",
      pendingTitle: "Your preview is being created…",
      pendingBody: "We're composing your personalized song. You'll receive an email as soon as it's ready.",
      pendingHint: "Average wait time is 30 to 60 minutes. This page will update automatically.",
      cartError: "Something went wrong. Check your connection and try again.",
      saveLabel: "Save",
      propRecipient: "For whom",
      propRecipientName: "Recipient first name",
      propStyle: "Music style",
      propOccasion: "Occasion",
      propPreviewUrl: "Preview heard",
      propStylePrompt: "Style prompt",
      propLyrics: "Lyrics"
    },
    de: {
      heroPrefix: "Entdecken Sie das personalisierte Lied für ",
      heroSuffix: "",
      playLabel: "Klicken Sie, um anzuhören",
      pauseLabel: "Pause",
      previewLabel: "⏱ Ausschnitt",
      durationLabel: "60s Vorschau",
      lockedLabel: "Vollständiges Lied gesperrt",
      emotionText: "Stellen Sie sich den Ausdruck auf <strong>{name}</strong>s Gesicht beim Hören dieses Liedes vor 😍. Ein zeitloses Geschenk für die Ewigkeit.",
      capacityMain: "Nur noch 3 Plätze in den nächsten 24h",
      capacitySub: "Um die Qualität zu sichern, produziert unser Studio nur eine begrenzte Anzahl Lieder pro Tag.",
      expiryLabel: "Ihre Hörprobe bleibt noch online",
      expirySub: "Unser Studio bewahrt Demos nicht länger als 24h online auf. Bestellen Sie Ihr Lied jetzt: <strong>wir überarbeiten es danach kostenlos, so oft wie nötig, bis es Ihnen gefällt.</strong>",
      studioNoteLabel: "✍️ Ein Wort aus unserem Studio",
      studioNoteSign: "Das YourMelody Studio",
      studioNoteFallback: "<strong>{name}</strong> kann sich glücklich schätzen, Sie zu haben. Danke, dass Sie uns dieses Lied anvertraut haben. Wir haben es mit viel Sorgfalt gestaltet und hoffen von Herzen, dass es Ihnen gefällt.",
      stickyCap: "Hörprobe verschwindet · 3 Plätze frei",
      stickyCapShort: "3 Plätze frei",
      stickyBtn: "Freischalten",
      offerLabel: "BEFRISTETES ANGEBOT",
      unlockPrefix: "Schalten Sie das vollständige Lied von ",
      unlockSuffix: " frei",
      offerSub: "Dieser Sonderpreis hält nicht ewig",
      expressTitle: "Lieferung in 30 Minuten",
      expressB1: "Vollständiges Lied per E-Mail in 30 Min",
      expressB2: "Studio absolute Priorität",
      expressB3: "Einmaliges Angebot",
      popularBadge: "AM BELIEBTESTEN",
      standardTitle: "24-Stunden-Lieferung",
      standardDesc: "Gleiches Lied, geliefert innerhalb von 24 Stunden",
      streamingTitle: "Spotify & Apple Music Streaming hinzufügen",
      streamingDesc: "Ihr Lied auf allen großen Plattformen veröffentlicht. Überall teilbar.",
      ctaMain: "Vollständiges Lied jetzt freischalten",
      trust1: "Sofortiger Zugang",
      trust2: "Für immer Ihnen",
      guaranteeTitle: "Zufriedenheitsgarantie",
      guaranteeBody: "Nicht zufrieden? Wir überarbeiten es kostenlos, bis es Ihnen gefällt.",
      socialProof: "Über 15.000 Lieder mit Liebe geliefert",
      includedTitle: "Was enthalten ist",
      inc1Title: "Sofortiger Zugang",
      inc1Desc: "Sofort nach dem Kauf verfügbar",
      inc2Title: "Für immer gehostet",
      inc2Desc: "Zugriff auf jedem Gerät",
      inc3Title: "Jederzeit herunterladen",
      inc3Desc: "HD-Audiodatei",
      inc4Title: "Kostenlose Überarbeitungen",
      inc4Desc: "Bis es Ihnen gefällt",
      faqTitle: "Häufig gestellte Fragen",
      faqQ1: "Wie erhalte ich mein Lied?",
      faqA1: "Ihr vollständiges Lied wird Ihnen per E-Mail als hochwertige MP3-Datei zugesendet, mit einem privaten Link zum Anhören und Herunterladen.",
      faqQ2: "Ist meine Zahlung sicher?",
      faqA2: "Ja. Alle Zahlungen werden von Shopify mit Bankverschlüsselung verarbeitet. Wir speichern niemals Ihre Kartendaten.",
      faqQ3: "Kann ich Änderungen anfordern?",
      faqA3: "Absolut. Sie haben 7 Tage nach Lieferung, um unbegrenzt kostenlose Änderungen anzufordern, bis das Lied Ihnen gefällt.",
      faqQ4: "Welches Audioformat erhalte ich?",
      faqA4: "Eine hochwertige MP3 (320 kbps), bereit zum Abspielen auf jedem Gerät, zum Teilen oder Importieren in Ihre Musikbibliothek.",
      loading: "Ihre Vorschau wird geladen…",
      errorTitle: "Vorschau nicht gefunden",
      errorBody: "Der verwendete Link ist ungültig oder abgelaufen.",
      errorCta: "Von vorne beginnen",
      pendingTitle: "Ihre Vorschau wird vorbereitet…",
      pendingBody: "Wir komponieren Ihr personalisiertes Lied. Sie erhalten eine E-Mail, sobald es fertig ist.",
      pendingHint: "Durchschnittliche Wartezeit: 30 bis 60 Minuten. Diese Seite wird automatisch aktualisiert.",
      cartError: "Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      saveLabel: "Sparen",
      propRecipient: "Für wen",
      propRecipientName: "Vorname Empfänger",
      propStyle: "Musikstil",
      propOccasion: "Anlass",
      propPreviewUrl: "Gehörter Ausschnitt",
      propStylePrompt: "Musikstil-Beschreibung",
      propLyrics: "Songtext"
    },
    es: {
      heroPrefix: "Descubre la canción personalizada de ",
      heroSuffix: "",
      playLabel: "Toca para escuchar",
      pauseLabel: "Pausa",
      previewLabel: "⏱ Extracto",
      durationLabel: "60s de vista previa",
      lockedLabel: "Canción completa bloqueada",
      emotionText: "Imagina lo que sentirá <strong>{name}</strong> al escucharla 😍. Un regalo que atesorará para siempre.",
      capacityMain: "Solo quedan 3 plazas en las próximas 24h",
      capacitySub: "Para mantener la calidad, nuestro estudio solo produce un número limitado de canciones al día.",
      expiryLabel: "Tu extracto sigue disponible aún",
      expirySub: "Nuestro estudio no conserva las demos en línea más de 24h. Reserva tu canción ahora: <strong>luego la retocamos gratis, tantas veces como haga falta, hasta que te encante.</strong>",
      studioNoteLabel: "✍️ Unas palabras de nuestro estudio",
      studioNoteSign: "El estudio YourMelody",
      studioNoteFallback: "<strong>{name}</strong> tiene mucha suerte de tenerte. Gracias por confiarnos esta canción. La hemos compuesto con mucho cuidado y esperamos de corazón que te encante.",
      stickyCap: "El extracto desaparece · 3 plazas restantes",
      stickyCapShort: "3 plazas restantes",
      stickyBtn: "Desbloquear",
      offerLabel: "OFERTA LIMITADA",
      unlockPrefix: "Desbloquea la canción completa de ",
      unlockSuffix: "",
      offerSub: "Esta oferta especial no durará para siempre",
      expressTitle: "Entrega en 30 minutos",
      expressB1: "Canción completa en tu correo en 30 min",
      expressB2: "Prioridad absoluta de estudio",
      expressB3: "Oferta única",
      popularBadge: "MÁS POPULAR",
      standardTitle: "Entrega en 24 horas",
      standardDesc: "Misma canción, entregada en 24 horas",
      streamingTitle: "Añadir streaming Spotify y Apple Music",
      streamingDesc: "Tu canción publicada en todas las plataformas principales. Compártela en todas partes.",
      ctaMain: "Desbloquear la canción completa",
      trust1: "Acceso instantáneo",
      trust2: "Tuya para siempre",
      guaranteeTitle: "Satisfacción garantizada",
      guaranteeBody: "¿No estás satisfecho? La revisamos gratis hasta que te encante.",
      socialProof: "Más de 15.000 canciones entregadas con amor",
      includedTitle: "Lo que incluye",
      inc1Title: "Acceso instantáneo",
      inc1Desc: "Desbloqueo inmediato tras la compra",
      inc2Title: "Alojada para siempre",
      inc2Desc: "Acceso en cualquier dispositivo",
      inc3Title: "Descarga ilimitada",
      inc3Desc: "Archivo de audio en alta calidad",
      inc4Title: "Revisiones gratuitas",
      inc4Desc: "Hasta que te encante",
      faqTitle: "Preguntas frecuentes",
      faqQ1: "¿Cómo recibiré mi canción?",
      faqA1: "Tu canción completa se enviará por correo como archivo MP3 de alta calidad, con un enlace privado para escuchar y descargar.",
      faqQ2: "¿El pago es seguro?",
      faqA2: "Sí. Todos los pagos son procesados por Shopify con cifrado bancario. Nunca almacenamos los datos de tu tarjeta.",
      faqQ3: "¿Puedo pedir modificaciones?",
      faqA3: "Por supuesto. Tienes 7 días tras la entrega para pedir revisiones gratuitas ilimitadas hasta que te encante.",
      faqQ4: "¿Qué formato de audio recibo?",
      faqA4: "Un MP3 de alta calidad (320 kbps), listo para reproducir en cualquier dispositivo, compartir o importar a tu biblioteca musical.",
      loading: "Cargando tu extracto…",
      errorTitle: "Extracto no encontrado",
      errorBody: "El enlace que has utilizado no es válido o ha expirado.",
      errorCta: "Empezar de nuevo",
      pendingTitle: "Tu extracto se está preparando…",
      pendingBody: "Estamos componiendo tu canción personalizada. Recibirás un correo en cuanto esté lista.",
      pendingHint: "El tiempo medio de espera es de 30 a 60 minutos. Esta página se actualizará automáticamente.",
      cartError: "Ha ocurrido un error. Comprueba tu conexión e inténtalo de nuevo.",
      saveLabel: "Ahorro",
      propRecipient: "Para quién",
      propRecipientName: "Nombre destinatario",
      propStyle: "Estilo musical",
      propOccasion: "Ocasión",
      propPreviewUrl: "Extracto escuchado",
      propStylePrompt: "Descripción estilo",
      propLyrics: "Letra"
    }
  };

  const listLocale = locale.startsWith('en') ? 'en'
                   : locale.startsWith('de') ? 'de'
                   : locale.startsWith('es') ? 'es'
                   : 'fr';
  const t = I18N[listLocale] || I18N.fr;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // ============================================================
  //  DOM refs
  // ============================================================
  const els = {};
  root.querySelectorAll('[data-ym]').forEach(el => {
    const key = el.getAttribute('data-ym');
    if (!els[key]) els[key] = el;
  });

  // Multiple recipient-name spans
  const recipientNameEls = root.querySelectorAll('[data-ym="recipient-name"], [data-ym="recipient-name-2"]');

  function showState(name) {
    ['loading', 'error', 'pending', 'ready'].forEach(k => {
      if (els[k]) els[k].hidden = (k !== name);
    });
    // App blocks slot only on ready
    const after = root.querySelector('[data-ym="after-cta-slot"]');
    if (after) after.hidden = (name !== 'ready');
  }

  // ============================================================
  //  Funnel telemetry — Meta Pixel custom events + GTM dataLayer
  //  PreviewLanded : the visitor's preview loaded successfully (landed on page)
  //  PreviewPlayed : the visitor pressed play for the first time (key intent)
  // ============================================================
  function ymTrack(eventName, extra) {
    const payload = Object.assign({ locale: locale }, extra || {});
    try { if (window.fbq) window.fbq('trackCustom', eventName, payload); } catch (e) {}
    try { if (window.gtag) window.gtag('event', eventName, payload); } catch (e) {}
    try {
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push(Object.assign({ event: 'ym_' + eventName.toLowerCase() }, payload));
      }
    } catch (e) {}
  }

  // ============================================================
  //  Apply localized strings
  // ============================================================
  function setText(key, value) {
    const el = root.querySelector('[data-ym="i18n-' + key + '"]');
    if (el) el.textContent = value;
  }

  function applyI18n() {
    setText('loading', t.loading);
    setText('error-title', t.errorTitle);
    setText('error-body', t.errorBody);
    setText('error-cta', t.errorCta);
    setText('pending-title', t.pendingTitle);
    setText('pending-body', t.pendingBody);
    setText('pending-hint', t.pendingHint);
    setText('hero-prefix', t.heroPrefix);
    setText('hero-suffix', t.heroSuffix);
    setText('preview-label', t.previewLabel);
    setText('locked-label', t.lockedLabel);
    setText('offer-label', t.offerLabel);
    setText('unlock-prefix', t.unlockPrefix);
    setText('unlock-suffix', t.unlockSuffix);
    setText('offer-sub', t.offerSub);
    setText('express-title', t.expressTitle);
    setText('express-b1', t.expressB1);
    setText('express-b2', t.expressB2);
    setText('express-b3', t.expressB3);
    setText('popular-badge', t.popularBadge);
    setText('standard-title', t.standardTitle);
    setText('standard-desc', t.standardDesc);
    setText('streaming-title', t.streamingTitle);
    setText('streaming-desc', t.streamingDesc);
    setText('cta-main', t.ctaMain);
    setText('trust-1', t.trust1);
    setText('trust-2', t.trust2);
    setText('guarantee-title', t.guaranteeTitle);
    setText('guarantee-body', t.guaranteeBody);
    setText('social-proof', t.socialProof);
    setText('included-title', t.includedTitle);
    setText('inc-1-title', t.inc1Title);
    setText('inc-1-desc', t.inc1Desc);
    setText('inc-2-title', t.inc2Title);
    setText('inc-2-desc', t.inc2Desc);
    setText('inc-3-title', t.inc3Title);
    setText('inc-3-desc', t.inc3Desc);
    setText('inc-4-title', t.inc4Title);
    setText('inc-4-desc', t.inc4Desc);
    setText('faq-title', t.faqTitle);
    setText('faq-q1', t.faqQ1);
    setText('faq-a1', t.faqA1);
    setText('faq-q2', t.faqQ2);
    setText('faq-a2', t.faqA2);
    setText('faq-q3', t.faqQ3);
    setText('faq-a3', t.faqA3);
    setText('faq-q4', t.faqQ4);
    setText('faq-a4', t.faqA4);

    // Urgency layer (capacity strip · expiry card · sticky bar)
    setText('capacity-main', t.capacityMain);
    setText('capacity-sub', t.capacitySub);
    setText('expiry-label', t.expiryLabel);
    const expSubEl = root.querySelector('[data-ym="i18n-expiry-sub"]');
    if (expSubEl) expSubEl.innerHTML = t.expirySub; // contient <strong>
    setText('studio-note-label', t.studioNoteLabel);
    setText('studio-note-sign', t.studioNoteSign);
    setText('sticky-btn', t.stickyBtn);
    const stickyCapEl = root.querySelector('[data-ym="sticky-cap"]');
    if (stickyCapEl) stickyCapEl.textContent = t.stickyCap;

    // Prices — viennent de Shopify Liquid (déjà localisés en bonne devise)
    const expressPriceEl = root.querySelector('[data-ym="express-price"]');
    const expressCompareEl = root.querySelector('[data-ym="express-compare"]');
    const expressSaveEl = root.querySelector('[data-ym="express-save"]');
    const standardPriceEl = root.querySelector('[data-ym="standard-price"]');
    const standardCompareEl = root.querySelector('[data-ym="standard-compare"]');
    const streamingPriceEl = root.querySelector('[data-ym="streaming-price"]');

    if (expressPriceEl) expressPriceEl.textContent = VARIANTS.express.price || '';
    if (expressCompareEl) expressCompareEl.textContent = VARIANTS.express.compare || '';
    if (expressSaveEl && VARIANTS.express.compare) {
      expressSaveEl.textContent = t.saveLabel;
    }
    if (standardPriceEl) standardPriceEl.textContent = VARIANTS.standard.price || '';
    if (standardCompareEl) standardCompareEl.textContent = VARIANTS.standard.compare || '';
    if (streamingPriceEl) streamingPriceEl.textContent = (VARIANTS.streaming.price ? '+ ' + VARIANTS.streaming.price : '');

    // Play label
    const playLabel = root.querySelector('[data-ym="play-label"]');
    if (playLabel) playLabel.textContent = t.playLabel;

    // Duration label (60s preview) — uses bare data-ym, not i18n- prefix
    const durEl = root.querySelector('[data-ym="duration-label"]');
    if (durEl) durEl.textContent = t.durationLabel;
  }
  applyI18n();

  // ============================================================
  //  Audio player (custom controls)
  // ============================================================
  const audio = root.querySelector('[data-ym="audio"]');
  const playBtn = root.querySelector('[data-ym="play-btn"]');
  const playIcon = root.querySelector('[data-ym="play-icon"]');
  const pauseIcon = root.querySelector('[data-ym="pause-icon"]');
  const progressBar = root.querySelector('[data-ym="progress-bar"]');
  const playLabelEl = root.querySelector('[data-ym="play-label"]');

  // Cap playback to 60 seconds (we deliver a preview, not the full track)
  const PREVIEW_MAX_SECONDS = 60;

  function setPlaying(isPlaying) {
    if (!playIcon || !pauseIcon) return;
    // Use setAttribute for reliable cross-browser hide on SVG elements
    if (isPlaying) {
      playIcon.setAttribute('hidden', '');
      pauseIcon.removeAttribute('hidden');
    } else {
      pauseIcon.setAttribute('hidden', '');
      playIcon.removeAttribute('hidden');
    }
    if (playLabelEl) playLabelEl.textContent = isPlaying ? t.pauseLabel : t.playLabel;
  }

  // setInterval-driven progress bar instead of `timeupdate` event because the latter
  // was firing spuriously (even paused) and snapping the width back to 0%. The interval
  // only ticks while audio is actually playing.
  let progressTicker = null;
  // Fire-once guards for the funnel telemetry events (PreviewLanded / PreviewPlayed).
  let landedTracked = false;
  let playedTracked = false;
  function startProgressTicker() {
    stopProgressTicker();
    progressTicker = setInterval(() => {
      if (!audio || audio.paused || audio.ended || !progressBar) return;
      if (audio.currentTime >= PREVIEW_MAX_SECONDS) {
        audio.pause();
        audio.currentTime = 0;
        progressBar.style.setProperty('width', '0%', 'important');
        stopProgressTicker();
        return;
      }
      const pct = (audio.currentTime / PREVIEW_MAX_SECONDS) * 100;
      progressBar.style.setProperty('width', pct + '%', 'important');
    }, 100);
  }
  function stopProgressTicker() {
    if (progressTicker) { clearInterval(progressTicker); progressTicker = null; }
  }

  if (audio && playBtn) {
    playBtn.addEventListener('click', () => {
      if (audio.paused) audio.play().catch(e => console.warn('[ym-preview] play failed', e));
      else audio.pause();
    });
    audio.addEventListener('play', () => {
      setPlaying(true);
      startProgressTicker();
      if (!playedTracked) {
        playedTracked = true;
        ymTrack('PreviewPlayed', {
          token: (previewData && previewData.token) || '',
          recipient_name: (previewData && previewData.recipient_name) || ''
        });
      }
    });
    audio.addEventListener('pause', () => { setPlaying(false); stopProgressTicker(); });
    audio.addEventListener('ended', () => { setPlaying(false); stopProgressTicker(); });
  }

  // ============================================================
  //  Render the preview data into the UI
  // ============================================================
  let previewData = null;

  // Studio note helper: bold the recipient name inside an already-escaped string.
  function boldName(text, nm) {
    if (!nm) return text;
    const e = esc(nm);
    return e ? text.split(e).join('<strong>' + e + '</strong>') : text;
  }

  // ============================================================
  //  Urgency layer — extract expiry countdown + sticky CTA bar
  // ============================================================
  function parseTs(v) {
    if (v === null || v === undefined || v === '') return NaN;
    if (typeof v === 'number') return v < 1e12 ? v * 1000 : v;   // secondes vs ms
    const n = Number(v);
    if (!isNaN(n)) return n < 1e12 ? n * 1000 : n;
    const d = Date.parse(v);                                     // ISO 8601
    return isNaN(d) ? NaN : d;
  }
  // Expiry epoch (ms). Priorité : API expires_at → API generated_at + 24h →
  // ancre localStorage par token (ne redémarre jamais sur le même appareil).
  function getExpiry(data) {
    let exp = parseTs(data.expires_at);
    if (isNaN(exp)) {
      const gen = parseTs(data.generated_at);
      if (!isNaN(gen)) exp = gen + 24 * 3600 * 1000;
    }
    if (isNaN(exp)) {
      const key = 'ym_exp_' + (data.token || 'x');
      const stored = parseInt(localStorage.getItem(key), 10);
      if (stored) { exp = stored; }
      else { exp = Date.now() + 24 * 3600 * 1000; try { localStorage.setItem(key, exp); } catch (e) {} }
    }
    return exp;
  }
  function fmtHMS(ms) {
    if (ms < 0) ms = 0;
    const s = Math.floor(ms / 1000), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
    const p = n => (n < 10 ? '0' : '') + n;
    return p(h) + ':' + p(m) + ':' + p(x);
  }
  let urgencyTicker = null;
  function startUrgency(data) {
    const sticky      = root.querySelector('[data-ym="sticky"]');
    const expiryCard  = root.querySelector('[data-ym="expiry"]');
    const timeEl      = root.querySelector('[data-ym="expiry-time"]');
    const stickyTimer = root.querySelector('[data-ym="sticky-timer"]');
    const stickyCap   = root.querySelector('[data-ym="sticky-cap"]');
    const stickyPrice = root.querySelector('[data-ym="sticky-price"]');
    const stickyBtn   = root.querySelector('[data-ym="sticky-btn"]');
    const playerEl    = root.querySelector('.ym-preview__player');

    // Sticky price follows the selected variant.
    function selPrice() {
      const sel = root.querySelector('[name="ym-variant"]:checked');
      const key = sel ? sel.value : 'express';
      return (VARIANTS[key] && VARIANTS[key].price) || '';
    }
    function syncPrice() { if (stickyPrice) stickyPrice.textContent = selPrice(); }
    root.querySelectorAll('[name="ym-variant"]').forEach(r => r.addEventListener('change', syncPrice));
    syncPrice();

    // Sticky button = same flow as the main buy CTA.
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (souvenirState && window.YMSouvenir) showSouvenir();
      else submitCart(null);
    });

    // Reveal the bar (translated off-screen by CSS) and slide it in past the player.
    if (sticky) sticky.hidden = false;
    function onScroll() {
      if (!sticky || !playerEl) return;
      const readyEl = root.querySelector('[data-ym="ready"]');
      const inReady = readyEl && !readyEl.hidden;
      const past = playerEl.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('ym-preview__sticky--show', !!(past && inReady));
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // Countdown.
    const expiry = getExpiry(data);
    function tick() {
      const left = expiry - Date.now();
      if (timeEl) timeEl.textContent = fmtHMS(left);
      if (stickyTimer) stickyTimer.textContent = fmtHMS(left);
      if (left <= 0) {
        if (urgencyTicker) clearInterval(urgencyTicker);
        if (expiryCard) expiryCard.hidden = true;             // disparaît simplement
        if (stickyTimer) stickyTimer.style.display = 'none';
        if (stickyCap) stickyCap.textContent = t.stickyCapShort;
      }
    }
    if (!isNaN(expiry) && expiry - Date.now() > 0) {
      if (expiryCard) expiryCard.hidden = false;
      tick();
      urgencyTicker = setInterval(tick, 1000);
    } else {
      if (stickyTimer) stickyTimer.style.display = 'none';
      if (stickyCap) stickyCap.textContent = t.stickyCapShort;
    }
  }

  function renderReady(data) {
    previewData = data;

    // Recipient name (multiple spots)
    const name = data.recipient_name || '';
    recipientNameEls.forEach(el => { el.textContent = name; });

    // Studio note — the AI-generated note from the API if present, else a safe
    // localized fallback (sparse input / generation failure). Both are HTML
    // (contain <strong>). The AI note is plain text from our own pipeline; we
    // still esc() it and only bold the recipient name.
    const emo = root.querySelector('[data-ym="emotion-text"]');
    if (emo) {
      const note = data.studio_note && String(data.studio_note).trim();
      emo.innerHTML = note
        ? boldName(esc(note), name)
        : t.studioNoteFallback.replace('{name}', esc(name));
    }

    // Audio source
    if (audio && data.audio_url) {
      audio.src = data.audio_url;
    }

    showState('ready');
    startUrgency(data);

    if (!landedTracked) {
      landedTracked = true;
      ymTrack('PreviewLanded', {
        token: data.token || '',
        recipient_name: data.recipient_name || ''
      });
    }
  }

  // ============================================================
  //  Cart submission (Unlock Full Song Now)
  // ============================================================
  const buyCta = root.querySelector('[data-ym="buy-cta"]');
  const cartErrorEl = root.querySelector('[data-ym="cart-error"]');

  function buildLineItemProperties() {
    if (!previewData) return {};
    const qa = previewData.quiz_answers || {};
    const props = {};
    // Visible to merchant: just the recipient first name (to identify the order at a glance).
    props[t.propRecipientName]  = qa.recipientName || previewData.recipient_name || '';
    // Hidden (underscore prefix = not shown in admin/checkout). The token is what the
    // Order Delivery scenario uses to find the customer + full song. Everything else
    // (lyrics, audio, style, occasion) already lives in the customer metafields, so we
    // no longer clutter the order line item with it.
    props['_locale']        = locale;
    props['_preview_token'] = previewData.token || '';
    // Drop empties
    Object.keys(props).forEach(k => { if (!props[k]) delete props[k]; });
    return props;
  }

  // Multipart /cart/add.js — uploads the photo File AND adds the physical product (plaque/magnet) in one call.
  async function uploadPhotoForVariant(variantId, extraProps, file) {
    const fd = new FormData();
    fd.append('id', String(variantId));
    fd.append('quantity', '1');
    Object.keys(extraProps || {}).forEach(function (k) {
      const v = extraProps[k];
      if (v !== null && v !== undefined && String(v).length > 0) {
        fd.append('properties[' + k + ']', String(v));
      }
    });
    fd.append('properties[Photo]', file, file.name);
    const resp = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
    if (!resp.ok) {
      const text = await resp.text();
      throw new Error('Photo upload failed (' + resp.status + '): ' + text.slice(0, 200));
    }
    return resp.json();
  }

  async function submitCart(physical) {
    if (!previewData) return;
    if (cartErrorEl) { cartErrorEl.hidden = true; cartErrorEl.textContent = ''; }

    // Get selected variant
    const selected = root.querySelector('[name="ym-variant"]:checked');
    const variantKey = selected ? selected.value : 'express';
    const mainVariantId = variantKey === 'express' ? VARIANTS.express.id : VARIANTS.standard.id;
    if (!mainVariantId) {
      if (cartErrorEl) { cartErrorEl.textContent = t.cartError + ' (variant config missing)'; cartErrorEl.hidden = false; }
      return;
    }

    const streamingChecked = !!root.querySelector('[data-ym="addon-streaming"]:checked');
    const props = buildLineItemProperties();

    const items = [{ id: Number(mainVariantId), quantity: 1, properties: props }];
    if (streamingChecked && VARIANTS.streaming.id) {
      items.push({ id: Number(VARIANTS.streaming.id), quantity: 1 });
    }

    // Souvenir physique (plaque/magnet [+ socle]) — optional, chosen on the souvenir step.
    const sv = (window.YMSouvenir && window.YMSouvenir.variants) || {};
    const hasPhysical = !!(physical && physical.product);
    if (hasPhysical && physical.product === 'plaque' && physical.socle && sv.socle) {
      items.push({ id: Number(sv.socle), quantity: 1 });
    }

    buyCta.disabled = true;
    if (window.YMSouvenir) window.YMSouvenir.setBusy(true);
    try {
      // 1. If a plaque/magnet + photo were chosen, upload the photo first (separate multipart call).
      if (hasPhysical && physical.photoFile) {
        const physVariantId = physical.product === 'plaque' ? sv.plaque : sv.magnet;
        if (physVariantId && !isNaN(Number(physVariantId))) {
          await uploadPhotoForVariant(Number(physVariantId), window.YMSouvenir.buildPhysicalProperties(), physical.photoFile);
        }
      }

      // 2. JSON batch add (song [+ streaming] [+ socle]).
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!resp.ok) {
        const txt = await resp.text();
        throw new Error('Cart add failed (' + resp.status + '): ' + txt.slice(0, 200));
      }

      // Meta Pixel tracking
      try {
        if (window.fbq) {
          window.fbq('track', 'AddToCart', {
            content_ids: items.map(i => String(i.id)),
            num_items: items.length,
            currency: 'EUR'
          });
          window.fbq('track', 'InitiateCheckout');
        }
        if (window.dataLayer && window.dataLayer.push) {
          window.dataLayer.push({ event: 'ym_preview_unlock', variant: variantKey, streaming: streamingChecked, souvenir: hasPhysical ? physical.product : 'none' });
        }
      } catch (e) {}

      // Redirect to checkout
      window.location.href = '/checkout';
    } catch (err) {
      console.error('[ym-preview] cart error', err);
      buyCta.disabled = false;
      if (window.YMSouvenir) { window.YMSouvenir.setBusy(false); window.YMSouvenir.showFormError(t.cartError); }
      if (cartErrorEl) {
        cartErrorEl.textContent = t.cartError;
        cartErrorEl.hidden = false;
      }
    }
  }

  // Buy CTA → show the souvenir upsell step first (instead of going straight to checkout).
  // The express/standard radio + streaming checkbox stay in the (hidden) ready DOM, so
  // submitCart() can still read them at confirm/skip time.
  const souvenirState = root.querySelector('[data-ym="souvenir"]');
  const readyState = root.querySelector('[data-ym="ready"]');
  function showSouvenir() {
    if (readyState) readyState.hidden = true;
    if (souvenirState) souvenirState.hidden = false;
    const sk = root.querySelector('[data-ym="sticky"]');
    if (sk) sk.classList.remove('ym-preview__sticky--show');
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
  }
  if (buyCta) {
    buyCta.addEventListener('click', function () {
      if (souvenirState && window.YMSouvenir) showSouvenir();
      else submitCart(null); // fallback: souvenir component absent → original behaviour
    });
  }
  if (window.YMSouvenir) {
    window.YMSouvenir.onSkip(function () { submitCart(null); });
    window.YMSouvenir.onConfirm(function (sel) { submitCart(sel); });
  }

  // ============================================================
  //  Boot — fetch preview data or use test mode
  // ============================================================
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('t');

  function tryTestMode() {
    const testAudio = urlParams.get('audio');
    const testName = urlParams.get('name');
    if (testAudio && testName) {
      renderReady({
        audio_url: testAudio,
        recipient_name: decodeURIComponent(testName.replace(/\+/g, ' ')),
        lyrics: urlParams.get('lyrics') ? decodeURIComponent(urlParams.get('lyrics').replace(/\+/g, ' ')) : '',
        style: urlParams.get('style') ? decodeURIComponent(urlParams.get('style').replace(/\+/g, ' ')) : '',
        relation: urlParams.get('relation') ? decodeURIComponent(urlParams.get('relation').replace(/\+/g, ' ')) : '',
        quiz_answers: {},
        token: 'test'
      });
      return true;
    }
    return false;
  }

  async function fetchPreview(retry) {
    retry = retry || 0;
    if (!apiUrl) {
      console.warn('[ym-preview] No API URL configured. Test mode only.');
      showState('error');
      return;
    }
    try {
      const resp = await fetch(apiUrl + '?t=' + encodeURIComponent(token), {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      });
      if (!resp.ok) throw new Error('API ' + resp.status);
      const data = await resp.json();

      if (data.audio_url) {
        // Robust: if the audio exists, the preview IS ready — show it even if the
        // preview_status flag is stale "pending" (a re-run of the capture can reset
        // the flag without clearing the audio). The audio's presence is the real proof.
        renderReady(data);
      } else if (data.status === 'pending' || data.status === 'processing') {
        showState('pending');
        if (retry < 20) setTimeout(() => fetchPreview(retry + 1), 30000);
      } else {
        showState('error');
      }
    } catch (e) {
      console.error('[ym-preview] fetch error', e);
      showState('error');
    }
  }

  if (!token) {
    showState('error');
  } else if (!tryTestMode()) {
    fetchPreview();
  }

  console.info('[ym-preview] init · locale=' + listLocale + ' · token=' + (token ? 'present' : 'missing'));
})();
